import React from 'react';
import { connect } from 'react-redux';
import ArchiveActionMenu from '@/components/ribbon-actions/ArchiveActionMenu';
import { findSelectedInCategory } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import SubscribeUserRegisteredAction from '@/notifications/subscriptions/components/SubscribeUserRegisteredAction';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import ReassignUsersAction from '@/roles/containers/ReassignUsersAction';
import { refreshUsers, showArchiveUsers } from '../actions';
import AutoApproveAction from './AutoApproveAction';
import UserGroupsLauncherMenu from '../groups/components/UserGroupsLauncherMenu';

const UsersActions = ({
  allowApproval,
  allowArchive,
  allowConfigurations,
  allowRefresh,
  allowRoleAssign,
  allowUserGroupsRead,
  category,
  disableArchive,
  isArchival,
  readStatus,
  refresh,
  showArchive,
}) => (
  <>
    {allowRefresh && (<RefreshActionMenu onClick={() => refresh(category, 1)} readStatus={readStatus} />)}
    {allowRoleAssign && (<ReassignUsersAction category={category} />)}
    {allowArchive && (
    <ArchiveActionMenu
      disabled={disableArchive}
      isArchival={isArchival || disableArchive}
      onClick={() => showArchive(category)}
    />
    )}
    {allowConfigurations && (<AutoApproveAction />)}
    {allowApproval && (<SubscribeUserRegisteredAction category={category} />)}
    {allowUserGroupsRead && <UserGroupsLauncherMenu />}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions }, users },
}, { category }) => {
  const { readStatus } = users[category];
  const selected = findSelectedInCategory(users, category);
  const isArchival = selected.some((user) => !user.archived);
  const denyArchive = isArchival && selected.some((user) => user.archived);

  return ({
    allowApproval: permissions.users.approve,
    allowArchive: permissions.users.destroy,
    allowConfigurations: permissions.configurations.update,
    allowRefresh: permissions.users.read,
    allowRoleAssign: permissions.roles.assign,
    allowUserGroupAssign: permissions.usergroups.assign,
    allowUserGroupsRead: permissions.usergroups.read,
    disableArchive: denyArchive || readStatus === states.PENDING || selected.length === 0,
    isArchival,
    readStatus,
  });
};

const mapDispatchToProps = {
  refresh: refreshUsers,
  showArchive: showArchiveUsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersActions);
